// @flow

import {
  GET_CAMPAIGN_DETAIL_REQUEST,
  GET_CAMPAIGN_DETAIL_SUCCESS,
  GET_CAMPAIGN_DETAIL_FAILURE,
  RESET_CAMPAIGN_DETAIL
} from 'src/stores/flow-type/campaign-planner.type';
import type { CampaignPlannerAction } from 'src/stores/flow-type/campaign-planner.type';

type CampaignPlannerState = {
  campaignDetail: ?Object,
  campaignDetailLoading: boolean
};

const initialState: CampaignPlannerState = {
  campaignDetail: null,
  campaignDetailLoading: false
};

const campaignPlannerReducers = (
  state: CampaignPlannerState = initialState,
  action: CampaignPlannerAction
) => {
  switch (action.type) {
    case GET_CAMPAIGN_DETAIL_REQUEST:
      return {
        ...state,
        campaignDetailLoading: true
      };
    case GET_CAMPAIGN_DETAIL_SUCCESS: {
      const { data = {} } = action.payload;

      return {
        ...state,
        campaignDetailLoading: false,
        campaignDetail: data
      };
    }
    case GET_CAMPAIGN_DETAIL_FAILURE:
      return {
        ...state,
        campaignDetailLoading: false
      };
    case RESET_CAMPAIGN_DETAIL:
      return {
        ...state,
        campaignDetail: null
      };
    default:
      return state;
  }
};

export default campaignPlannerReducers;
